const {getAsset} = require("utils");

let projects =
[
	{
		name: "PiperCode",
		type: ["React"],
		//image: getAsset("projects/pipercode/cover.png"),
		image: getAsset("projects/pipercode/splash-resized.jpg"),
		website: "https://www.buildpiper.com/pages/pipercode",
		//caseStudy: true,
	},
	{
		name: "OffToYou",
		type: ["LAMP"],
		image: getAsset("projects/offtoyou/new_home_pic.jpg"),
		website: "https://offtoyou.com",
		//caseStudy: true,
	},
	{
		name: "San Francisco Limo",
		type: ["LAMP"],
		image: getAsset("projects/sflimo/events.JPG"),
		website: "http://sflimo.net",
		//caseStudy: true,
	},
	{
		name: "TicTacToe",
		type: ["Java"],
		image: getAsset("projects/tictactoe/cover.png"),
		github: "https://github.com/andrew4699/TicTacToe",
		website: "http://anguterman.com/tictactoe",
		caseStudy: true,
	},
	{
		name: "Lawless Boards",
		type: ["LAMP"],
		image: getAsset("projects/lawlessboards/section.png"),
		github: "https://github.com/andrew4699/Lawless-Boards",
		//caseStudy: true,
	},
	{
		name: "Angu",
		type: ["C#", "Chrome"],
		image: getAsset("projects/angu/cover.jpg"),
		github: "https://github.com/andrew4699/Angu",
		//caseStudy: true,
	},
	{
		name: "LogiSound",
		type: ["C#"],
		image: getAsset("projects/logisound/mystery.jpg"),
		//caseStudy: true,
	},
	{
		name: "RapidComms",
		type: ["C#"],
		image: getAsset("projects/rapidcomms/cover.jpg"),
		github: "https://github.com/andrew4699/RapidComms",
		//caseStudy: true,
	},
	{
		name: "Audis",
		type: ["LAMP"],
		image: getAsset("projects/audis/cover.png"),
		github: "https://github.com/andrew4699/Audis",
		website: "http://anguterman.com/audis",

	},
	{
		name: "Linkify",
		type: ["Chrome"],
		image: getAsset("projects/linkify/mdn.png"),
		github: "https://github.com/andrew4699/Linkify",
		//caseStudy: true,
	},
	{
		name: "HearthDraft",
		type: ["NodeJS"],
		image: getAsset("projects/hearthdraft/classes-smaller.jpg"),
		github: "https://github.com/andrew4699/Node-Hearthstone-Draft",
		//caseStudy: true,
	},
	{
		name: "Andrew.io",
		type: ["NodeJS"],
		//image: getAsset("projects/andrewio/poster-smaller.png"),
		image: getAsset("projects/andrewio/login.jpg"),
		//caseStudy: true,
	},
	{
		name: "File Manager",
		type: ["LAMP"],
		image: getAsset("projects/filemanager/selected.png"),
		github: "https://github.com/andrew4699/File-Manager",
		//caseStudy: true,
	},
];

module.exports = projects;


// WEBPACK FOOTER //
// ./src/js/projects.js